// extracted by mini-css-extract-plugin
export default {"element":"InfoBox-module--element--6e62a","container":"InfoBox-module--container--df108","list":"InfoBox-module--list--02d8d"};